// extracted by mini-css-extract-plugin
export default {"downloadButton":"DownloadData_downloadButton__OEs2L","rs-dropdown-open":"DownloadData_rs-dropdown-open__k7qJY","wrapper":"DownloadData_wrapper__ib4k9"};